import { render, staticRenderFns } from "./DriverCreateModal.vue?vue&type=template&id=b10b0266&scoped=true"
import script from "./DriverCreateModal.vue?vue&type=script&lang=js"
export * from "./DriverCreateModal.vue?vue&type=script&lang=js"
import style0 from "./DriverCreateModal.vue?vue&type=style&index=0&id=b10b0266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10b0266",
  null
  
)

export default component.exports